import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  getCategary,
  getDegree,
  getIndustry,
  getLanguage,
  getProficiency,
  getSkills,
} from "../../../../redux/categary/action";
import { GetCountry } from "../../../../redux/master/action";
import EAboutYou from "./CompanyFlow/EAboutYou";
import EAddSkills from "./CompanyFlow/EAddSkills";
import EAddPortfolio from "./CompanyFlow/EAddPortfolio";
import EAddEduction from "./CompanyFlow/EAddEduction";
import EAddLanguage from "./CompanyFlow/EAddLanguage";
import EAddBXP from "./CompanyFlow/EAddBXP";
import EBankDetails from "./CompanyFlow/EBankDetails";
import IAboutYou from "./IndiviualFlow/IAboutYou";
import IAddExperience from "./IndiviualFlow/IAddExperience";
import IAddSkills from "./IndiviualFlow/IAddSkills";
import IAddPortfolio from "./IndiviualFlow/IAddPortfolio";
import IAddEduction from "./IndiviualFlow/IAddEduction";
import IAddCVPreferences from "./IndiviualFlow/IAddCVPreferences";
import IAddLanguage from "./IndiviualFlow/IAddLanguage";
import IAddBXP from "./IndiviualFlow/IAddBXP";
import IBankDetails from "./IndiviualFlow/IBankDetails";
import EJobPreferences from "./CompanyFlow/EJobPreferences";
import { useLocation } from "react-router-dom";
import ManageExpertProfile from "../../ManageProfile/ManageExpertProfile/ManageExpertProfile";
import { IS_TEST_MODE } from "../../../../assests/extention/commonfunction";

const DifferentFlow = () => {
  const location = useLocation();
  const { state } = location;

  const path = "Assets/scss/expertregisteration.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // dispatch(getSkills());
    // dispatch(getCategary());
    dispatch(getDegree());
    dispatch(getLanguage());
    dispatch(GetCountry());
    dispatch(getProficiency());
    dispatch(getIndustry());
  }, [dispatch]);

  useEffect(() => {
    scrollToTop();
  }, [currentPage]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const formdata = {
    profile_image: "",
    first_name: "",
    last_name: "",
    country_title: "",
    category_id: "",
    designation: "",
    details: "",
    education: [],
    experience: [],
    bxp: [],
    work_sample: [],
    portfolio: [],
    certificates: [],
    industries: [],
    iam: state?.type || 1,
    expert: {
      designation: "",
      about: "",
      price_per_hour: "",
      price_per_month: "",
      national_id: "",
    },
    company: {
      cr_number: "",
      about: "",
      price_per_hour: "",
      price_per_month: "",
      company_name: "",
      wathq_verification: "",
      price_per_month: "",
      national_id: "",
    },
  }
  const [formData, setFormData] = useState(formdata);
  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const previousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const renderPage = () => {
    if (formData?.iam == 2) {
      switch (currentPage) {
        case 1:
          return (
            <EAboutYou
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
              formdata={formdata}
            />
          );
        case 2:
          return (
            <EAddSkills
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 3:
          return (
            <EAddPortfolio
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 4:
          return (
            <EJobPreferences
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        // case 5:
        //   return (
        //     <EAddBXP
        //       formData={formData}
        //       setFormData={setFormData}
        //       nextPage={nextPage}
        //       previousPage={previousPage}
        //     />
        //   );
        case 5:
          return (
            <EBankDetails
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 6:
          return (
            <ManageExpertProfile
              formData={formData}
              setFormData={setFormData}
              previousPage={previousPage}
              edittype={2}
            />
          );
        default:
          return null;
      }
    } else {
      switch (currentPage) {
        case 1:
          return (
            <IAboutYou
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
              formdata={formdata}
            />
          );
        case 2:
          return (
            <IAddEduction
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 3:
          return (
            <IAddSkills
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 4:
          return (
            <IAddPortfolio
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 5:
          return (
            <IAddExperience
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 6:
          return (
            <IAddCVPreferences
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 7:
          return (
            <IAddLanguage
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        // case 8:
        //   return (
        //     <IAddBXP
        //       formData={formData}
        //       setFormData={setFormData}
        //       nextPage={nextPage}
        //       previousPage={previousPage}
        //     />
        //   );
        case 8:
          return (
            <IBankDetails
              formData={formData}
              setFormData={setFormData}
              nextPage={nextPage}
              previousPage={previousPage}
            />
          );
        case 9:
          return (
            <ManageExpertProfile
              formData={formData}
              setFormData={setFormData}
              previousPage={previousPage}
              edittype={2}
            />
          );
        default:
          return null;
      }
    }
  };

  return (
    <>
      {IS_TEST_MODE &&
        <>
          {currentPage < 20 ? (
            <>
              <button type="button" onClick={previousPage} className="next-button">
                previous
              </button>
              <button type="button" onClick={nextPage} className="next-button">
                Next
              </button>
            </>
          ) : null}
        </>
      }
      <div>{currentPage == 10 && formData?.iam == 1 ? renderPage() : ""}</div>
      <div>{currentPage == 7 && formData?.iam == 2 ? renderPage() : ""}</div>
      {((currentPage == 10 && formData?.iam == 1) ||
        (currentPage == 7 && formData?.iam == 2)) == true ? (
        ""
      ) : (
        <div className="app-container col-md-8 mx-auto expert-flow">
          {renderPage()}
        </div>
      )}
    </>
  );
};

export default DifferentFlow;
